import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { EmergencyPowerSettingsUpdateDto, EmergencyPowerSettingsDto } from 'src/Libs/emergency-power/api/dto'
import { handleFetchError } from 'src/Libs/api/utils'
import { EmergencyPowerSettingsModel } from '../models'
import { fromDtoToModel } from '../transformers'

/**
 * Get Emergency Power settings of a single storage device
 *
 * @param serialNumber Storage serial number
 * @param authFetch
 * @throws UnexpectedApiResponseError if an unhandled api error appears
 */
export const getEmergencyPowerSettingsByStorage = async (
  serialNumber: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<EmergencyPowerSettingsModel>> => {
  try {
    const response = await authFetch<EmergencyPowerSettingsDto>({
      path: `storages/${serialNumber}/hardware/emergency-power/overview`,
      method: 'GET',
      payload: undefined,
    })

    if (response.status === StatusCodes.OK) {
      const model = fromDtoToModel(response.data as EmergencyPowerSettingsDto)
      return new ApiResult<EmergencyPowerSettingsModel>(model)
    }
    return new ApiResult<EmergencyPowerSettingsModel>(null, true)
  } catch (error) {
    return handleFetchError<EmergencyPowerSettingsModel>(error)
  }
}

/**
 * Updates the Emergency Power setting for a storage device
 * @param serialNumber Storage serial number
 * @param model
 * @param authFetch
 * @throws UnexpectedApiResponseError if an unhandled api error appears
 */
export const updateSettings = async (
  serialNumber: string,
  model: EmergencyPowerSettingsUpdateDto,
  authFetch: AuthFetchWithResponse
): Promise<void> => {
  const response = await authFetch<void>({
    path: `storages/${serialNumber}/hardware/emergency-power/overview`,
    method: 'PUT',
    payload: JSON.stringify(model),
  })
  if (response.status !== StatusCodes.NO_CONTENT) {
    throw new UnexpectedApiResponseError(response.status)
  }
}
